import { useState } from "react";

import ListUnsuitableContainer from "@/components/shared/business/ListUnsuitableContainer/ListUnsuitableContainer";
import { UNSUITABLE_REASON_KEYS } from "@/components/shared/business/UnsuitableReason/constants/unsuitableReason.constants";
import { usePublicationListFilterQuery } from "@api/publicationList/usePublicationListFilter";
import { DRAFT_STATUS_CODE } from "@constants/draftStatusCode.constants";
import { formatDate } from "@utils/formatDate";
import { handlePublicationListError } from "@utils/handleDraftError";

import ListMultipleShell from "./components/ListMultipleShell/ListMultipleShell";
import ListStatusContainer from "./components/ListStatusContainer/ListStatusContainer";
import PublicationTitleContainer from "./components/TitleContainer/PublicationTitleContainer";
import * as S from "./PublicationListTableBody.style";
import { EMPTY_SHELL_VALUE } from "../../constants/publicationListTable.constants";

const EDITOR_LIST: ("mcEditor" | "ftEditor")[] = ["mcEditor", "ftEditor"];

const WRITE_DATE_LIST = ["startDate", "completeDate"];

const PublicationListTableBody = () => {
  const [activeModalId, setActiveModalId] = useState<string | null>(null);

  const { data: publicationListData, refetch: updatePublicationList } =
    usePublicationListFilterQuery();

  return (
    <S.ListTableBody>
      {publicationListData?.data.map((listItem) => {
        return (
          <S.ListTableTr
            key={`row-${listItem.publicationId}`}
            isError={handlePublicationListError(listItem)[0]}
          >
            <S.ListTableId>
              {listItem?.publicationId || EMPTY_SHELL_VALUE}
            </S.ListTableId>
            <S.ListTableId>{listItem?.doi || EMPTY_SHELL_VALUE}</S.ListTableId>
            <S.PublicationDate>
              {listItem?.publicationDate || EMPTY_SHELL_VALUE}
            </S.PublicationDate>
            <S.PublicationType>
              {listItem?.publicationType || EMPTY_SHELL_VALUE}
            </S.PublicationType>
            <S.TopicType>
              {listItem?.topicType || EMPTY_SHELL_VALUE}
            </S.TopicType>
            <S.JournalName>
              {listItem?.journalName || EMPTY_SHELL_VALUE}
            </S.JournalName>
            <S.Volume>{listItem?.volume || EMPTY_SHELL_VALUE}</S.Volume>
            <S.Issue>{listItem?.issue || EMPTY_SHELL_VALUE}</S.Issue>
            <S.ListTableUnsuitable
              isUnsuitable={
                listItem.draftArticleStatusHighest ===
                DRAFT_STATUS_CODE.unsuitable
              }
              isModalOpen={activeModalId === listItem.publicationId}
            >
              <ListUnsuitableContainer
                onModalStateChange={(isOpen) => {
                  if (isOpen) {
                    setActiveModalId(listItem?.publicationId || null);
                  } else if (activeModalId === listItem.publicationId) {
                    setActiveModalId(null);
                  }
                }}
                id={Number(listItem.publicationId)}
                articleRejectReason={listItem?.articleRejectReason || ""}
                duplArticleId={null}
                draftArticleStatusHighest={listItem.draftArticleStatusHighest}
                mcEditorName={listItem.mcEditorName}
                aiDone={listItem.aiDone}
                unsuitableReasonUsageType={
                  UNSUITABLE_REASON_KEYS.publicationList
                }
              />
            </S.ListTableUnsuitable>
            <PublicationTitleContainer
              listItem={listItem}
              updatePublicationList={updatePublicationList}
              ListData={publicationListData?.data}
            />
            <S.AffiliationList>
              <ListMultipleShell
                name={listItem?.affiliationList || EMPTY_SHELL_VALUE}
              />
            </S.AffiliationList>
            <S.StatusTableData
              key={listItem.publicationId}
              code={listItem.draftArticleStatusHighest}
            >
              <ListStatusContainer data={listItem} />
            </S.StatusTableData>
            {WRITE_DATE_LIST.map((dateKey) => (
              <S.ListTableDate key={dateKey}>
                {listItem[dateKey as keyof typeof listItem]
                  ? formatDate(
                      listItem[dateKey as keyof typeof listItem] as string,
                      "YY.MM.DD HH:mm:ss",
                    )
                  : EMPTY_SHELL_VALUE}
              </S.ListTableDate>
            ))}
            {EDITOR_LIST.map((editor) => (
              <S.ListTableEditor key={editor}>
                {listItem[editor] || EMPTY_SHELL_VALUE}
              </S.ListTableEditor>
            ))}
          </S.ListTableTr>
        );
      })}
    </S.ListTableBody>
  );
};

export default PublicationListTableBody;
